module.exports = __webpack_public_path__ + "static/media/fedpa-provider.90cb6407.svg";